export function ErrorAlert({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="rounded border border-red-300 bg-red-50 text-red-700 text-sm px-3 py-2 mb-4">
      {message}
    </div>
  );
}
